import { sortTimelineEvents } from '@/components/timelineEvents/timelineEventHelpers';
import { antGrey, runwayColors } from '@/components/styles/globalStyles';
import { EventsTimeline } from '../../../components/timelineEvents/EventsTimeline';
import { ReleaseType, TimelineEvent } from '@/types';
import { ClockCircleOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers/reducers';
import { selectRelease } from '../../../selectors/selectors';
import { Link } from 'react-router-dom';
import { createTimelineEventsRoute } from '../../../helpers/routeHelpers';
import { ReleaseTimelineSectionContext } from '../../timelineEvents/EventsTimeline';

export interface ReleaseTimelineWidgetProps {
    orgId: string;
    appId: string;
    releaseId: string;
    events: TimelineEvent[];
    maxHeight?: number;
    releaseType: ReleaseType;
}

export const ReleaseTimelineWidget: React.FC<ReleaseTimelineWidgetProps> = ({
    orgId,
    appId,
    releaseId,
    events,
    releaseType,
    maxHeight = 200,
}) => {
    const sortedEvents = sortTimelineEvents(events);
    const release = useSelector((state: RootState) => selectRelease(state, releaseId));

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                alignItems: 'end',
                width: '100%',
            }}
        >
            <div
                style={{
                    borderColor: antGrey.grey5,
                    borderWidth: 1,
                    borderStyle: 'solid',
                    padding: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8,
                    borderRadius: 8,
                    position: 'relative',
                    backgroundColor: runwayColors.white,
                    width: '100%',
                    maxHeight,
                    overflow: 'hidden',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: 30,
                        zIndex: 1,
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0), ${runwayColors.white})`,
                    }}
                />
                <EventsTimeline
                    isLoading={false}
                    events={sortedEvents}
                    maxItemsToDisplay={4}
                    orgId={orgId}
                    appId={appId}
                    release={release}
                    releaseType={releaseType}
                    shouldHideUpcomingEvents={true}
                    context={ReleaseTimelineSectionContext.AppHome}
                />
            </div>
            <Space>
                <Link
                    to={{
                        pathname: createTimelineEventsRoute(orgId, appId, releaseId),
                    }}
                >
                    <Button
                        type="link"
                        style={{
                            fontSize: 13,
                            fontWeight: 200,
                            paddingRight: 0,
                        }}
                    >
                        <div
                            style={{
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 8,
                                height: '100%',
                            }}
                        >
                            Full timeline
                            <ClockCircleOutlined
                                style={{
                                    fontSize: 14,
                                    color: runwayColors.info,
                                    verticalAlign: 'middle',
                                    padding: '2px',
                                }}
                            />
                        </div>
                    </Button>
                </Link>
            </Space>
        </div>
    );
};
